import React from 'react';
import Svg from './Svg';

export default function Facebook(props) {
  return (
    <Svg
      {...props}
      d="M740.75,113.9c40.2,0 74.4,14.4 102.6,43.2c28.2,28.8 42.3,62.7 42.3,101.7l0,482.4c0,39.6 -14.1,73.5 -42.3,101.7c-28.2,28.2 -62.4,42.6 -102.6,43.2l-93.6,0l0,-299.7l99.9,0l14.4,-116.1l-114.3,0l0,-74.7c0,-18.6 3.9,-32.4 11.7,-41.4c7.8,-9 23.1,-13.8 45.9,-14.4l61.2,-0.9l0,-103.5c-21,-3 -51,-4.5 -90,-4.5c-45,0 -81.3,13.2 -108.9,39.6c-27.6,26.4 -41.1,64.5 -40.5,114.3l0,85.5l-100.8,0l0,116.1l100.8,0l0,299.7l-267.3,0c-40.2,0 -74.4,-14.4 -102.6,-43.2c-28.2,-28.8 -42.3,-62.7 -42.3,-101.7l0,-482.4c0,-39.6 14.1,-73.5 42.3,-101.7c28.2,-28.2 62.4,-42.6 102.6,-43.2l481.5,0Z"
    />
  );
}
